var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarketingIcon = function SvgMarketingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    fill: "none",
    viewBox: "0 0 74 74"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m8.455 38.706 1.415-3.579-3.304-8.358a2.74 2.74 0 0 1-.047-1.88 2.85 2.85 0 0 1 1.184-1.492l7.764-4.889 2.423-8.632a2.83 2.83 0 0 1 1.107-1.548 3 3 0 0 1 1.868-.536l9.261.454 7.221-5.62A3 3 0 0 1 39.187 2a3 3 0 0 1 1.84.626l7.22 5.62 9.262-.445a3 3 0 0 1 1.868.536c.542.38.932.925 1.107 1.548l2.423 8.632 7.764 4.89c.56.352.978.878 1.185 1.492.207.613.19 1.276-.048 1.879l-3.3 8.358 3.3 8.356c.238.603.255 1.266.048 1.88a2.85 2.85 0 0 1-1.185 1.495l-7.764 4.873-2.435 8.636a2.83 2.83 0 0 1-1.106 1.55 3 3 0 0 1-1.87.536l-9.261-.445-7.22 5.608M2 63.25 6.375 72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M50.125 54.739 5.235 67.625 2 62.949 31.8 28.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m17.313 65.438 1.06 3.035a7.4 7.4 0 0 0 2.09 2.176c.842.58 1.797.985 2.805 1.192a7.8 7.8 0 0 0 3.062.014 7.7 7.7 0 0 0 2.817-1.168 8.12 8.12 0 0 0 3.326-5.06c.405-2.038.057-3.761-1.086-5.514"
  })));
};
export default SvgMarketingIcon;